var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.msTime.show
      ? _c("p", [
          _vm.msTime.day > 0
            ? _c("span", [
                _c("span", [_vm._v(_vm._s(_vm.msTime.day))]),
                _c("i", [_vm._v(_vm._s(_vm.dayTxt))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.msTime.hour))]),
          _c("i", [_vm._v(_vm._s(_vm.hourTxt))]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.msTime.minutes))]),
          _c("i", [_vm._v(_vm._s(_vm.minutesTxt))]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.msTime.seconds))]),
          _c("i", [_vm._v(_vm._s(_vm.secondsTxt))])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-97f8fc7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97f8fc7c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-countdown/lib/vue2-countdown.vue
// module id = null
// module chunks = 